export default __webpack_public_path__ + "static/media/2xl-circle-o-plus.69f0ce60.svg";